var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterAcceptSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment method icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44.3333,
    height: 31,
    rx: 3.5,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44.3333,
    height: 31,
    rx: 3.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Left",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9053 22.4392C21.3266 23.7699 19.2787 24.5733 17.0409 24.5733C12.0478 24.5733 8 20.5737 8 15.6399C8 10.7062 12.0478 6.7066 17.0409 6.7066C19.2787 6.7066 21.3266 7.50993 22.9053 8.84066C24.484 7.50993 26.5319 6.7066 28.7697 6.7066C33.7629 6.7066 37.8106 10.7062 37.8106 15.6399C37.8106 20.5737 33.7629 24.5733 28.7697 24.5733C26.5319 24.5733 24.484 23.7699 22.9053 22.4392Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9062 22.4392C24.8502 20.8007 26.0828 18.3625 26.0828 15.6399C26.0828 12.9173 24.8502 10.4792 22.9062 8.84066C24.485 7.50993 26.5329 6.7066 28.7706 6.7066C33.7638 6.7066 37.8116 10.7062 37.8116 15.6399C37.8116 20.5737 33.7638 24.5733 28.7706 24.5733C26.5329 24.5733 24.485 23.7699 22.9062 22.4392Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9031 22.4392C24.847 20.8007 26.0796 18.3625 26.0796 15.6399C26.0796 12.9174 24.847 10.4792 22.9031 8.8407C20.9592 10.4792 19.7266 12.9174 19.7266 15.6399C19.7266 18.3625 20.9592 20.8007 22.9031 22.4392Z",
    fill: "#FF5E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterAcceptSvg);
export default __webpack_public_path__ + "static/media/MasterAcceptSvg.765e047fd6dd33b5bfdea419ce30bac5.svg";
export { ForwardRef as ReactComponent };